import coco1 from "@/assets/avatars/coco-1.png";
import coco2 from "@/assets/avatars/coco-2.png";
import coco3 from "@/assets/avatars/coco-3.png";
import coco4 from "@/assets/avatars/coco-4.png";
import coco5 from "@/assets/avatars/coco-5.png";
import coco6 from "@/assets/avatars/coco-6.png";
import coco7 from "@/assets/avatars/coco-7.png";
import coco8 from "@/assets/avatars/coco-8.png";
import coco9 from "@/assets/avatars/coco-9.png";
import coco10 from "@/assets/avatars/coco-10.png";

export interface AvatarOption {
  id: string;
  label: string;
  src: string;
}

export const COCO_AVATARS: AvatarOption[] = [
  { id: "coco-1", label: "سلام", src: coco1 },
  { id: "coco-2", label: "آفرین", src: coco2 },
  { id: "coco-3", label: "قلب", src: coco3 },
  { id: "coco-4", label: "باحال", src: coco4 },
  { id: "coco-5", label: "مطالعه", src: coco5 },
  { id: "coco-6", label: "شادی", src: coco6 },
  { id: "coco-7", label: "فکر", src: coco7 },
  { id: "coco-8", label: "کار", src: coco8 },
  { id: "coco-9", label: "موسیقی", src: coco9 },
  { id: "coco-10", label: "خواب", src: coco10 },
];

const byId = Object.fromEntries(COCO_AVATARS.map((a) => [a.id, a]));

export function resolveAvatarSrc(avatarUrl?: string | null): string | null {
  if (!avatarUrl) return null;
  if (byId[avatarUrl]) return byId[avatarUrl].src;
  // Allow absolute/media URLs from backend as-is.
  if (
    avatarUrl.startsWith("http://") ||
    avatarUrl.startsWith("https://") ||
    avatarUrl.startsWith("/") ||
    avatarUrl.startsWith("data:")
  ) {
    return avatarUrl;
  }
  return null;
}
